import { render } from "./StafetDonationStepVirksomhed.vue?vue&type=template&id=52a281ea"
import script from "./StafetDonationStepVirksomhed.vue?vue&type=script&lang=js"
export * from "./StafetDonationStepVirksomhed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__